import { render, staticRenderFns } from "./BDXManagementTableFiltersBDXStatus.vue?vue&type=template&id=4aecff48"
import script from "./BDXManagementTableFiltersBDXStatus.vue?vue&type=script&lang=js"
export * from "./BDXManagementTableFiltersBDXStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports